import {
  Button,
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import { Fragment, useState, useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import {checkApi} from "../../Authentication/AxiosInstance";
import LoadingPage from "../common/LoadingPage";
import ErrorPage from "../common/ErrorPage";
import { groupByAgentName } from "./utils"; // Import the grouping function # actually by url & agent
import DisclaimerBanner from "../common/Disclaimers";
export const ExamNotices = () => {
  const [open, setOpen] = useState(1);
  const [hiddenAgents, setHiddenAgents] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [fullScreen, setFullScreen] = useState(false);
  const [groupedData, setGroupedData] = useState();
  const [notices, setNotices] = useState([]);
  const [lastImportDates, setLastImportDates] = useState({});
  const [startIndex, setStartIndex] = useState(0);
  const noticesPerPage = 6;
  const noticesRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(0);

 
  const formatDate = (datetimeString) => {
    if (!datetimeString) return "No Date Available";
    const dateObj = new Date(datetimeString);
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();

    const formattedDate = dateObj.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });

    if (hours === 0 && minutes === 0) {
        return formattedDate;
    }

    const formattedTime = dateObj.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    return `${formattedDate}, ${formattedTime}`; // Non-breaking space after comma
  };

  const fetchExamNotices = async () => {
    try {
      const res = await checkApi.get("/cetzone/examnotices/");
      const contentType = res.headers["content-type"];
  
      if (!contentType || !contentType.includes("application/json")) {
        console.error("❌ Not JSON:", res.data);
        throw new Error("Expected JSON, got something else.");
      }
      return res.data;
    } catch (error) {
      if (error.response) {
        console.error("Server error response:", error.response.data);
        throw new Error(`HTTP ${error.response.status}`);
      } else {
        console.error("Network or other error:", error.message);
        throw error;
      }
    }
    
  };

  const { data, status } = useQuery({
    queryKey: ["examnotices"],
    queryFn: fetchExamNotices,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    throwOnError: true,
  });
  
  const buttonCSS =  "m-2 p-2 normal-case text-base text-primary-900 font-semibold tracking-wider shadow-none rounded-sm bg-white pl-3 pr-3 pt-1 pb-1 hover:bg-primary-900 hover:text-white hover:shadow-md hover:rounded-md"
  //const contentCSS =  "m-2 p-2 normal-case text-sm font-bold bg-white pl-3 pr-3 pt-1 pb-1 border-primary-500 border-2 text-primary-500 shadow-md rounded-md"
  const contentCSS = `m-2 p-2 h-auto w-fit 
                      bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                      border-2 rounded-lg 
                      text-base font-bold tracking-widest normal-case items-center`;

  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
      </svg>
    );
  }
  const fetchNoticePDF = async(noticeId) => {
    try {
        const res = await checkApi.get(`/cetzone/examnotices/${noticeId}/pdf/`, { responseType: "blob" });
        const url = URL.createObjectURL(res.data)
        if (window.innerWidth < 768) {
          // On mobile: open in new tab
          window.open(url, "_blank");
        } else {
          // On desktop: show inline iframe
          setPdfUrl(url);
        }
      } catch (error) {
          console.error('Error Loading PDF', error)
      }
  }
  
  const toggleFullScreen = () => {
    setFullScreen(!fullScreen);
  };

  const removeAgentFromView = (agent) => {
    // Collapse the accordion if it's open
    if (open === agent) {
      setOpen(0);
    }
    // Remove agent from view
    setHiddenAgents((prevHiddenAgents) =>
      prevHiddenAgents.includes(agent)
        ? prevHiddenAgents.filter((a) => a !== agent)
        : [...prevHiddenAgents, agent]
    );
    // Clear PDF if it was showing
    setPdfUrl(null);
  };

  const handleAgentHeaderClick = (agent) => {
    setOpen((open)=>(open === agent ? 0 : agent))
    setPdfUrl(null)
    setStartIndex(0)
  };

  const showAllAgents = () => {
    setHiddenAgents([]);
    // Optionally reset the open accordion to first one or close all
    // setOpen(0); // Uncomment if you want to close all accordions when showing all
  };

  const handlePrevious = (agent, totalNotices) => {
    setStartIndex((prev) => Math.max(prev - noticesPerPage, 0));
  };

  const handleNext = (agent, totalNotices) => {
    setStartIndex((prev) => Math.min(prev + noticesPerPage, totalNotices - (totalNotices % noticesPerPage || noticesPerPage)));
  };
  
  const containsLinkWords = (text) => {
    return /\b(Click|Link)\b/i.test(text);
  };
  
  useEffect(() => {
    if (data) {
      setNotices(data.notices);
      setLastImportDates(data.last_import_dates);
    }
  },[data])
  
  useEffect(() => {
    if (notices && notices.length) {
      const grouped = groupByAgentName(notices,'exams');
      setGroupedData(grouped);
    }
  },[notices]);

  useEffect(() => {
    if (noticesRef.current) {
      setIframeHeight(noticesRef.current.offsetHeight);
    }
  }, [noticesRef.current?.offsetHeight]); // rerun if height changes
  console.log(status);
  console.log(notices);
  console.log(lastImportDates);
  return (
    <Fragment>
      {status === 'loading' && <LoadingPage />}
      {status === 'error' && <ErrorPage />}
      {status === 'success' && (
        <div>
          <div className="flex flex-col md:flex-row overflow-x-hidden w-full p-3 sm:p-4 md:p-5 gap-3 sm:gap-4 md:gap-x-5">
            <div className={`w-full ${fullScreen ? 'hidden' : 'md:w-1/2'} overflow-y-auto`}>
              
              <div className="items-center">
                {/* Important Announcements and view all Notices section start*/}
                <div className="flex flex-col sm:flex-row pt-4 gap-3 sm:justify-between sm:items-center w-full">
                  <h1 className='text-lg sm:text-xl md:text-2xl text-secondary-900 font-bold'> Important Announcements</h1>
                  <Button onClick={showAllAgents} className={`${buttonCSS} text-sm sm:text-base w-full sm:w-auto`}>View All Notices</Button>
                </div>
                {/* Important Announcements and view all Notices section complete*/}
                {/* LHS Content Display Part section start*/}
                <div ref={noticesRef} className="pl-2 pr-2 border-2 border-primary-500">
                  { groupedData && Object.entries(groupedData).map(([agent, notices], index) => {
                    const [agentName, agentWebsite] = agent.split('-');
                    const visibleNotices = notices.slice(startIndex, startIndex + noticesPerPage)
                    //console.log(visibleNotices)
                    return (
                      <div key={agent} className="m-1 h-auto">
                        <Accordion className="mt-0 mb-0 pr-1 mr-1" open={open === agent} 
                                  icon={<Icon id={agent} open={open} />}> 

                          {/* Header with Agent Part section start*/}
                          {!hiddenAgents.includes(agent) && (
                            <AccordionHeader 
                                    key={agent} 
                                    className="shadow-md shadow-primary-200 mr-1 min-h-16 sm:h-14 py-2 sm:py-0" 
                                    onClick={() => handleAgentHeaderClick(agent)}>
                              <div className="w-full">
                                  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full gap-2 sm:gap-0">
                                    <div className="flex gap-x-2 items-center">
                                        <label className="font-semibold text-sm sm:text-base md:text-lg mt-1 mb-1 text-primary-900 tracking-wide break-words">{agentName}</label>
                                        <span className= "p-1 sm:p-0 m-0 bg-white-200 text-base shadow-none flex-shrink-0"
                                                  onClick={(e) => { e.stopPropagation(); removeAgentFromView(agent); }}
                                                  onKeyDown={(e)=> {
                                                    if (e.key === 'Enter'|| e.key === " ") {
                                                        removeAgentFromView(agent);
                                                    }
                                                  }}>
                                                  <i className="fas fa-trash text-gray-500 text-base sm:text-lg hover:text-red-500"></i>
                                        </span>
                                    </div>
                                    <div className="text-xs sm:text-sm break-words">
                                      <div className="flex flex-col sm:flex-row gap-1 sm:gap-0">
                                          <span className="font-semibold sm:font-normal">Website: &nbsp;</span>
                                          <a href={agentWebsite} target="_blank" rel="noopener noreferrer" 
                                                className="text-blue-500 hover:underline break-all">
                                                {agentWebsite}
                                          </a>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex text-xs sm:text-sm font-normal mt-1">
                                    {console.log(lastImportDates[agentName])}
                                    {console.log(agentName)}
                                      <span className="font-semibold sm:font-normal">Updated On: </span>{formatDate(lastImportDates[agentName])}
                                  </div>
                              </div>
                                
                            </AccordionHeader>
                          )}
                          {/* Header with Agent Part section complete*/}
                          <div
                              className={`overflow-hidden transition-max-height duration-500 ease-in-out ${
                                  (open === agent) ? 'max-h-1000' : 'max-h-0'
                                }`} >
                              {visibleNotices?.map((notice, noticeIndex) => {
                                 const hasLinkRef = containsLinkWords(notice.e001_noticetitle);
                                 return (
                                  <AccordionBody key={noticeIndex} className="border-b-[1px] border-b-secondary-900 focus:outline-none py-3 sm:py-2">
                                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-x-2 text-sm sm:text-base md:text-md font-normal focus:outline-none">
                                      <div className="focus:outline-none min-w-[80px] sm:whitespace-nowrap text-xs sm:text-sm font-semibold sm:font-normal">
                                        {formatDate(notice.e001_noticeissued).split(", ").map((part, index) => (
                                          <span key={index}>
                                            {part}
                                            {index === 0 && <br />} {/* Add line break after the first part (date) */}
                                          </span>
                                        ))}
                                      </div>
                                      
                                      <div className="focus:outline-none min-h-min p-2 box-border overflow-hidden flex-1">
                                          <div className="break-words" title={ hasLinkRef 
                                                ? 'This notice refers to clickable links. Please visit the official website to access them.'
                                                : ''
                                            }
                                          >
                                            {/* if the notice has clickable links, show two stars and hover message to visit official site*/}
                                            {hasLinkRef && <strong className="text-red-600">**</strong>} 
                                            <span className="text-sm sm:text-base md:text-md">{notice.e001_noticetitle}</span>
                                          </div>
                                      </div>
                                      {notice.e001_haspdf_c &&  
                                          <div className="focus:outline-none flex-shrink-0">
                                              <Button className={`${contentCSS} text-xs sm:text-sm md:text-base w-full sm:w-auto px-3 sm:px-2 py-2 sm:py-1`}
                                              onClick={() => fetchNoticePDF(notice.id)}>View Notice</Button>
                                          </div>
                                      }
                                    </div>
                                      
                                  </AccordionBody>
                                )
                              })}
                          </div>
                          {/* Limit data to 6 rows and show View More Button */}
                          {(open === agent) && notices.length > 6 && 
                            <div  className="flex flex-row justify-between align-center gap-2 mt-2"
                                  onMouseDown={(e) => e.preventDefault()}> 
                                <Button className = {`${contentCSS} flex text-xs sm:text-sm md:text-base px-3 sm:px-2 py-2 sm:py-1 flex-1 sm:flex-initial`}
                                        
                                        disabled={startIndex === 0} 
                                        onClick={() => handlePrevious(agent)}>
                                        Previous
                                </Button>
                                <Button className = {`${contentCSS} flex text-xs sm:text-sm md:text-base px-3 sm:px-2 py-2 sm:py-1 flex-1 sm:flex-initial`}
                                        disabled={startIndex + noticesPerPage >= notices.length} 
                                        onClick={() => handleNext(agent, notices.length)}>
                                        Next
                                </Button>
                              </div>
                          }
                        </Accordion>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            {/* LHS Content Display Part section complete*/}
            {/* RHS PDF Display Part section start*/}
            {pdfUrl && (
              <div className={`hidden md:block ${fullScreen ? 'w-full' : 'md:w-1/2'} h-full overflow-y-auto mr-5 border-[1px]`}>
                <div class="flex flex-row mt-4">
                  <div class="flex ml-0 mr-auto justify-start text-secondary-900 font-bold"></div>
                  <div class="flex ml-auto mr-0 justify-end">
                        <Button
                            onClick={toggleFullScreen}
                            className={`${buttonCSS}`}
                          >
                            {fullScreen ? 'Exit Full Screen' : 'Full Screen'}
                        </Button>
                  </div>
                </div>
                
                <div className="h-auto overflow-y-auto">
                      <iframe src={pdfUrl} style={{ minHeight: `${iframeHeight}px` }} className="w-full border-0" title="PDF Viewer" /> 
                </div> 
              </div>
              )}
            {/* RHS PDF Display Part section complete*/}
          </div>
          <DisclaimerBanner/>
        </div>
      )}
    </Fragment>
  );
};

